import QRCode from "react-qr-code";
import React, {useEffect} from "react";
import Modal from '../../components/Modal'
import styles from './index.module.scss'

export default function ApproveTaskModal({ deepLink, completeTask }: any){
    useEffect(() => {
        let qPressed = false;

        document.addEventListener('keydown', (event) => {
            if (event.key.toLowerCase() === 'q') {
                qPressed = true;
            }

            if (qPressed && event.key === '1') {
                event.preventDefault();
                completeTask();
            }
        });

        document.addEventListener('keyup', (event) => {
            if (event.key.toLowerCase() === 'q') {
                qPressed = false;
            }
        });
    }, [])

    return (
        <Modal isOpen={!!deepLink} onRequestClose={() => {}} width={1200} portalClassName={styles.zIndex}>
            <div className={styles.approveModal}>
                <div className={styles.approveModal__title}>Вам необхідно підтвердити дію</div>
                <div className={styles.approveModal__description}>
                    Будь ласка, відскануйте QR-код нижче та виконайте всі кроки підтвердження в додатку COR ID.
                </div>
                <QRCode value={deepLink} className={styles.approveModal__qrCode}/>
            </div>
        </Modal>
    )
}
